import { render } from "./InputPhoneNumber.vue?vue&type=template&id=195a25fc&scoped=true"
import script from "./InputPhoneNumber.vue?vue&type=script&lang=ts"
export * from "./InputPhoneNumber.vue?vue&type=script&lang=ts"

import "./InputPhoneNumber.vue?vue&type=style&index=0&id=195a25fc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-195a25fc"

export default script